var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hitokoto"},[_c('div',{staticClass:"hitokoto-box"},[_c('span',{staticClass:"hitokoto-content"},[_vm._v(_vm._s(_vm.data.hitokoto))]),_vm._v(" "),_c('span',{staticClass:"hitokoto-from"},[_vm._v("——"+_vm._s(_vm.data.from))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-650af21e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hitokoto.vue
// module id = null
// module chunks = 